import Navbar from './Navbar';
import Footer from './Footer';
import CountdownRibbon from './CountdownRibbon';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <CountdownRibbon />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
